/**
 * 描述：初始化所有axios请求实例
**/
import Vue from 'vue'
import commApiRequest from './commApiRequest'
import { getLiveApi, getOnlineApi, getDataApi, getLiveHyApi, getOnlineNotFixApi,getTenghuiApi} from '@/utils/useProxyApi'

export default function initSystemAxiosInstance() {

    const liveApi = getLiveApi()
    Vue.prototype.$liveApi = commApiRequest(liveApi)

    const onlineApi = getOnlineApi()
    Vue.prototype.$axios = commApiRequest(onlineApi)

    const dataApi = getDataApi()
    Vue.prototype.$liveUser = commApiRequest(dataApi)

    const liveHyApi = getLiveHyApi()
    Vue.prototype.$subApi = commApiRequest(liveHyApi)

    const onlineNotFixApi = getOnlineNotFixApi()
    Vue.prototype.$onlineApi = commApiRequest(onlineNotFixApi)
    console.log('[<-- Vue.prototype.$onlineApi -->]',Vue.prototype.$onlineApi);
    

    const tenghuiApi=getTenghuiApi()
    console.log('tenghuiApi',tenghuiApi);
    Vue.prototype.$tenghuiApi = commApiRequest(tenghuiApi)
}